/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-04-17 10:00:00
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, TextContainer } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  active: boolean,
  removing: boolean,
  handleCancel: () => void
};

type ComposedProps = Props & WithI18nProps;

class RemoveOldVersionConfirmModal extends Component<ComposedProps> {
  render() {
    const { active, handleCancel, handleRemove, i18n, removeOldThemeLoading } = this.props;

    return (
      <Modal
        open={active}
        onClose={handleCancel}
        title={i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.remove_oldversion_modal_title')}
        primaryAction={{
          destructive: true,
          content: i18n.translate('AdminHTML.Common.Action.remove'),
          loading: removeOldThemeLoading,
          onAction: handleRemove
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.Common.Action.cancel'),
            onAction: handleCancel
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            <p>
              {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.remove_oldversion_modal_msg1', {
                b: (
                  <b>
                    {i18n.translate(
                      'AdminHTML.ThemeSetup.NewThemeSetup.remove_oldversion_modal_msg1_b'
                    )}
                  </b>
                )
              })}
            </p>
            <p style={{ marginTop: '8px' }}>
              {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.remove_oldversion_modal_msg2')}
            </p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }
}

export default withI18n()(connect(null, null)(RemoveOldVersionConfirmModal));
